import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createDashboardAnalytic = async (token, params) => {
  const objectName = 'dashboard_analytic'
  const url = `dashboards/${params.dashboard_id}/dashboard_analytics`

  const data = await apiPost({ url, token, objectName, params })
  return data
}

export function useCreateDashboardAnalytic({ params, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (mutationParams) => {
      // Use mutationParams if provided, otherwise fall back to params
      const finalParams = mutationParams || params
      return createDashboardAnalytic(token, finalParams, finalParams.id)
    },
    { ...options }
  )
}

const updateDashboardAnalytic = async (token, id, params) => {
  const objectName = 'dashboard_analytic'
  const url = `dashboard_analytics/${id}`

  const data = await apiPatch({ url, token, objectName, params })
  return data
}

export function useUpdateDashboardAnalytic({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => {
      // If params includes an id, use it; otherwise use the id from hook config
      const updateId = params?.id || id
      const updateParams = params?.id ? { ...params, id: undefined } : params
      return updateDashboardAnalytic(token, updateId, updateParams)
    },
    { ...options }
  )
}

const deleteDashboardAnalytic = async (token, id) => {
  const url = `dashboard_analytics/${id}`

  const data = await apiDelete({ url, token })
  return data
}

export function useDeleteDashboardAnalytic({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (deleteId) => {
      // Use the runtime deleteId if provided, otherwise use id from hook config
      const finalId = deleteId || id
      return deleteDashboardAnalytic(token, finalId)
    },
    { ...options }
  )
}
